export default {"src":"/_next/static/media/bottomBar.249db6ef.svg","height":88,"width":375};